import { useMemo, useState } from 'react'
import { CardContainer, VerticalContainer, VerticalMainContainer } from '@shared/designSystem/Containers'
import { H1Title, H2Title } from '@shared/designSystem/Titles'
import { Text } from '@shared/designSystem/Texts'
import FilterPillGroup, { FilterPillOption } from '@shared/designSystem/FilterPillGroup'
import designSystemStyles from '@shared/styles/designSystemStyles'

interface DemoUser {
    id: string
    name: string
    isActive: boolean
}

const users: DemoUser[] = [
    { id: '1', name: 'Ana', isActive: true },
    { id: '2', name: 'Bruno', isActive: true },
    { id: '3', name: 'Carla', isActive: false },
]

const FilterPillShowcaseScreen = () => {
    const [selectedId, setSelectedId] = useState<string>('all')

    const counts = useMemo(() => {
        const active = users.filter((user) => user.isActive).length
        return { all: users.length, active, inactive: users.length - active }
    }, [])

    const options: FilterPillOption[] = [
        { id: 'all', label: 'Todos'.localized(), count: counts.all },
        { id: 'active', label: 'Activos'.localized(), count: counts.active, dotColor: designSystemStyles.colorSuccess },
        { id: 'inactive', label: 'Inactivos'.localized(), count: counts.inactive, dotColor: designSystemStyles.colorTextMuted },
    ]

    const filteredUsers = users.filter((user) => {
        if (selectedId === 'active') {
            return user.isActive
        }
        if (selectedId === 'inactive') {
            return !user.isActive
        }
        return true
    })

    return (
        <VerticalMainContainer>
            <VerticalContainer gap={designSystemStyles.gapSm} alignment="left">
                <H1Title text="FilterPillGroup Showcase" />

                <H2Title text="Con contador y punto de estado" />
                <FilterPillGroup
                    ariaLabel={'Filtrar por estado'.localized()}
                    selectedId={selectedId}
                    onSelect={setSelectedId}
                    options={options}
                />

                <CardContainer>
                    <VerticalContainer gap={designSystemStyles.gapXxxSm} alignment="left">
                        {filteredUsers.map((user) => (
                            <Text key={user.id} text={user.name} />
                        ))}
                    </VerticalContainer>
                </CardContainer>

                <H2Title text="Tamaño small" />
                <FilterPillGroup
                    ariaLabel={'Filtrar por estado (small)'.localized()}
                    selectedId={selectedId}
                    onSelect={setSelectedId}
                    size="small"
                    options={options}
                />
                <FilterPillGroup
                    ariaLabel={'Filtros small cargando'.localized()}
                    selectedId={selectedId}
                    onSelect={setSelectedId}
                    size="small"
                    isLoading
                    options={options}
                />

                <H2Title text="Cargando (contadores esqueleto)" />
                <FilterPillGroup
                    ariaLabel={'Filtros cargando'.localized()}
                    selectedId={selectedId}
                    onSelect={setSelectedId}
                    isLoading
                    options={options}
                />

                <H2Title text="Sin puntos de estado" />
                <FilterPillGroup
                    ariaLabel={'Filtrar sin puntos'.localized()}
                    selectedId={selectedId}
                    onSelect={setSelectedId}
                    options={[
                        { id: 'all', label: 'Todos'.localized(), count: counts.all },
                        { id: 'active', label: 'Activos'.localized(), count: counts.active },
                        { id: 'inactive', label: 'Inactivos'.localized(), count: counts.inactive, isDisabled: true },
                    ]}
                />
            </VerticalContainer>
        </VerticalMainContainer>
    )
}

export default FilterPillShowcaseScreen
